module.exports = __webpack_public_path__ + "static/media/1.9e5d6ef5.jpg";